module.exports = __webpack_public_path__ + "static/smartphone_app-8ac2f75c2ffcad0720cb53366ba191fa.png";